<ion-header class="header">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button color="dark" (click)="dismissModal()">
        <ion-icon name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <!-- <ion-buttons slot="end">
      <ion-button color="dark" (click)="reset()">
        <ion-icon name="refresh"></ion-icon>
      </ion-button>
    </ion-buttons> -->
    <ion-title color="dark">
      {{ 'SIGNATURE.MODAL.TITLE' | translate }}
    </ion-title>
  </ion-toolbar>
</ion-header>
<ion-content>
  <div class="signature-input">
    <canvas
      #canvas
      id="signature-pad"
      class="signature-pad-canvas"
      width="900"
      height="400"
      style="touch-action: none"
    >
    </canvas>
  </div>
  <!-- shape="round" -->
  <ion-buttons>
    <ion-button color="dark" [disabled]="isCanvasBlank()" (click)="reset()">
      {{ 'SIGNATURE.MODAL.BUTTON.RESET' | translate }}
    </ion-button>
    <ion-button
      color="color"
      [disabled]="isCanvasBlank()"
      (click)="validateSignature()"
    >
      {{ 'SIGNATURE.MODAL.BUTTON.VALIDATE' | translate }}
    </ion-button>
  </ion-buttons>
  <!-- <ion-button
    id="validateBtn"
    strong
    expand="full"
    [disabled]="isCanvasBlank()"
    (click)="validateSignature()"
  >
    {{ 'SIGNATURE.MODAL.BUTTON.RESET' | translate }}
  </ion-button>
  <ion-button
    id="validateBtn"
    strong
    expand="full"
    [disabled]="isCanvasBlank()"
    (click)="validateSignature()"
  >
    {{ 'SIGNATURE.MODAL.BUTTON.VALIDATE' | translate }}
  </ion-button> -->
</ion-content>
